import { JButton } from '@atoms/JButton';
import { AuthCard } from '@authentication/components/AuthCard';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMemo } from 'react';
import JTextFieldForm from '@atoms/JTextFieldForm';

import useForgotPasswordMutation from '@authentication/mutations/useForgotPasswordMutation';
import { ErrorLoginTypography } from './forgot-passwrod-card.styled';
import LetterIcon from '../../../svg/change-password.svg';

const initialValues = {
  username: '',
};

const forgotPasswordSchema = Yup.object().shape({
  username: Yup.string().email('invalid email').required('required'),
});

const ForgotPasswordCard = () => {
  const { t } = useTranslation();

  const {
    mutate: forgotPassword,
    isError,
    isSuccess,
  } = useForgotPasswordMutation();

  const methods = useForm<{ username: string }>({
    mode: 'onChange',
    defaultValues: useMemo(() => initialValues, [initialValues]),
    resolver: yupResolver(forgotPasswordSchema),
  });

  const { formState, handleSubmit, getValues } = methods;
  const { isDirty, isValid } = formState;

  const onSubmit = handleSubmit((data) => {
    forgotPassword(data);
  });
  const usernameValue = getValues('username');
  return (
    <AuthCard title={t('CHANGE_YOUR_PW')}>
      {isSuccess ? (
        <Stack
          gap={3}
          justifyContent={'center'}
          alignItems={'center'}
          p={3}
          textAlign={'center'}
        >
          <img src={LetterIcon} alt="mySvgImage" />
          <Typography variant="caption">
            {t('WE_SEND_EMAIL_TIP_1')}{' '}
            <Typography variant="body2" component={'span'} fontWeight={'bold'}>
              {usernameValue}
            </Typography>
            {', '}
            {t('WE_SEND_EMAIL_TIP_2')}
          </Typography>
        </Stack>
      ) : (
        <>
          <FormProvider {...methods}>
            <form onSubmit={onSubmit} autoComplete="off">
              <Stack gap={1}>
                <JTextFieldForm
                  name="username"
                  data-qa="username"
                  fullWidth
                  noBorder
                  label={t('EMAIL') ?? ''}
                />

                {isError && (
                  <ErrorLoginTypography data-qa="error-message">
                    {t('EMAIL_OR_PASSWORD_IS_INCORRECT')}
                  </ErrorLoginTypography>
                )}
                <JButton
                  data-qa="login-button"
                  variant="contained"
                  color="primary"
                  type="submit"
                  guttertop
                  disabled={!isValid || !isDirty}
                >
                  {t('CONTINUE')}
                </JButton>
              </Stack>
            </form>
          </FormProvider>
          <Typography variant="caption">{t('FORGOT_PASSWORD_TIP')}</Typography>
        </>
      )}
    </AuthCard>
  );
};

export default ForgotPasswordCard;
